import { getToken } from '../services/token.service';
import { API_GATEWAY_URI } from 'common/constants/api-urls';
import { generatePusherPrivateChannelName } from '@linearb/linjs-common';

const PUSHER_AUTH_CHANNEL_ENDPOINT = `${API_GATEWAY_URI}/api/v1/rest/auth/pusher/auth-channel`;

export function connectPusher(pusherAppKey, pusherCluster, organizationId) {
  if (!window.pusher && window.Pusher) {
    const token = getToken();

    // eslint-disable-next-line no-undef
    window.pusher = new Pusher(pusherAppKey, {
      cluster: pusherCluster,
      channelAuthorization: {
        endpoint: PUSHER_AUTH_CHANNEL_ENDPOINT,
        headers: {
          authorization: `Bearer ${token}`
        }
      }
    });

    const channelName = generatePusherPrivateChannelName(organizationId);
    window.pusher.subscribe(channelName);
  }
}

export function disconnectPusher() {
  if (window.pusher) {
    window.pusher.disconnect();
  }
}
